import $ from 'jquery';
import MicroModal from 'micromodal';

$(function () {
    // Modales
    function openModal(modalComponent) {
        modalComponent.addClass('modal-visible');
        $('html, body').addClass('modal-is-open');
    }

    function closeModal(modalComponent) {
        modalComponent.removeClass('modal-visible');
        $('html, body').removeClass('modal-is-open');
    }

    const $modals = $('.modal-component');

    $modals.each(function () {
        const $modalComponent = $(this);
        const $modal = $(this).find('.modal');
        const $btnOpenModal = $(this).find($('.btn-open-modal'));
        const $btnCloseModal = $(this).find($('.btn-close-modal'));

        $btnOpenModal.on('click', function (e) {
            e.preventDefault();
            if ($modalComponent.hasClass('modal-visible')) {
                closeModal($modalComponent);
            } else {
                openModal($modalComponent);
            }
        });
        $btnCloseModal.on('click', function () {
            closeModal($modalComponent);
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest($modal).length && !$(e.target).closest($btnOpenModal).length && $modalComponent.hasClass('modal-visible')) {
                e.preventDefault();
                closeModal($modalComponent);
            }
        });
    });

    // MicroModal
    MicroModal.init({
        awaitCloseAnimation: true,
        disableScroll: true,
        disableFocus: true,
        onShow: (modal) => {
            $('html').addClass('modal-is-open');
            if ($('.custom-video-player', modal)) {
                const video = $('video', modal)[0];
                video.play();
            }
        },
        onClose: (modal) => {
            $('html').removeClass('modal-is-open');
            if ($('.custom-video-player', modal)) {
                const video = $('video', modal)[0];
                video.pause();
                video.currentTime = 0;
            }
        },
    });
});
